var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandHortColour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "600.3pt",
    height: "135.79pt",
    viewBox: "0 0 600.3 135.79",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m393.3 2.207h205.01v131.5h-205.01z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m391 0h209.3v136h-209.3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "br"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43 0h193v136.37h-193z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m134 0h188v136.37h-188z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "av"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m217 0h216v136.37h-216z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m365 0h184v136.37h-184z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 72h26v3h-26z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 71h26v4h-26z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 70h26v5h-26z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ck"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 69h26v6h-26z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ci"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ch"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 68h26v7h-26z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 68h26v6h-26z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 67h26v7h-26z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 67h27v7h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "by"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 67h27v6h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 66h27v7h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 66h27v6h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 65h27v7h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 65h27v6h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 64h27v7h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 64h27v6h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 63h27v7h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 63h27v6h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "be"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 62h27v7h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 62h28v7h-28z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 62h28v6h-28z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "az"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ay"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527 62h27v6h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ax"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527 61h27v7h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "au"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "at"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527 61h27v6h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "as"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527 60h27v7h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ap"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527 60h27v6h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "an"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527 59h27v7h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "al"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527 59h27v6h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527 58h27v7h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527 58h27v6h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527 57h28v7h-28z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527 57h28v6h-28z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m528 57h27v6h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m528 56h27v7h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m528 56h27v6h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m528 55h27v7h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m528 55h27v6h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m528 55h27v5h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m528 55h27v4h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m528 55h28v4h-28z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m528 55h28v3h-28z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m529 55h27v3h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m529 55h27v2h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m529 55h27v1h-27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17187-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63672l10.41 10.41c0.29297 0.28906 0.76563 0.28906 1.0586 0l16.469-16.473c0.17188-0.17188 0.17188-0.45703 0-0.63281l-2.2773-2.2773c-0.0859-0.08594-0.20312-0.12891-0.31641-0.12891-0.11718 0-0.23046 0.04297-0.3164 0.12891"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.0039062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 135.8h459.13v-135.79h-459.13z",
    fill: "#1c3d75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 135.8h458.96v-135.79h-458.96z",
    fill: "#1c3d75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m393.3 133.71h205.01v-131.5h-205.01z",
    fill: "#eb7d21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m393.3 133.71h205.01v-131.5h-205.01z",
    fill: "#eb7d21"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cn)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m3933 26.63h2050.1v1315h-2050.1z",
    fill: "none",
    stroke: "#1c3d75",
    strokeMiterlimit: 10,
    strokeWidth: 40
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m3933 26.591h2050.1v1315h-2050.1z",
    fill: "none",
    stroke: "#1c3d75",
    strokeMiterlimit: 10,
    strokeWidth: 40
  })), /*#__PURE__*/React.createElement("path", {
    d: "m144.69 39.996h-17.801c-1.9062 0-3.5391 0.83203-4.8125 2.0312-1.1836 1.2969-1.9062 2.957-1.9062 4.9023v39.176c0 1.8477 0.72266 3.6055 1.9062 4.8047 1.2734 1.293 2.9062 2.0312 4.8125 2.0312h25.609c1.8164 0 3.5469-0.73828 4.7266-2.0312 1.1797-1.1992 1.9961-2.957 1.9961-4.8047v-29.848zm-17.801-1.1094h18.344l14.898 16.816 0.17968 0.37109v30.031c0 2.2188-0.90625 4.1562-2.2695 5.6367-1.4531 1.3867-3.4492 2.3086-5.543 2.3086h-25.609c-2.1797 0-4.1758-0.92188-5.5391-2.3086-1.4531-1.4805-2.3633-3.418-2.3633-5.6367v-39.176c0-2.2188 0.91015-4.2539 2.3633-5.6406 1.3633-1.4766 3.3594-2.4023 5.5391-2.4023",
    fill: "#1c3d75"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m1446.9 963.74h-178.01c-19.062 0-35.391-8.3203-48.125-20.312-11.836-12.969-19.062-29.57-19.062-49.023v-391.76c0-18.477 7.2266-36.055 19.062-48.047 12.734-12.93 29.062-20.312 48.125-20.312h256.09c18.164 0 35.469 7.3828 47.266 20.312 11.797 11.992 19.961 29.57 19.961 48.047v298.48zm-178.01 11.094h183.44l148.98-168.16 1.7968-3.7109v-300.31c0-22.188-9.0625-41.562-22.695-56.367-14.531-13.867-34.492-23.086-55.43-23.086h-256.09c-21.797 0-41.758 9.2188-55.391 23.086-14.531 14.805-23.633 34.18-23.633 56.367v391.76c0 22.188 9.1015 42.539 23.633 56.406 13.633 14.766 33.594 24.023 55.391 24.023z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.69 54.32c-1.3633-1.4805-2.2734-3.5117-2.2734-5.6367v-9.2383c0-0.09766 0.0937-0.28125 0.1836-0.375 0.27343-0.18359 0.54296-0.18359 0.8164 0l14.715 16.543c0.0898 0.08984 0.17968 0.27734 0.17968 0.46094 0 0.27734-0.26953 0.55469-0.54297 0.55469h-7.5391c-2.0898 0-4.0859-0.92578-5.4492-2.3086zm-1.1836-5.6367c0 1.8477 0.82031 3.6016 2 4.8047 1.2695 1.293 2.9062 2.0312 4.7226 2.0312h6.2656l-12.988-14.598",
    fill: "#1c3d75"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m1466.9 820.5c-13.633 14.805-22.734 35.117-22.734 56.367v92.383c0 0.97656 0.9375 2.8125 1.836 3.75 2.7343 1.8359 5.4297 1.8359 8.164 0l147.15-165.43c0.8984-0.89844 1.7968-2.7734 1.7968-4.6094 0-2.7734-2.6953-5.5469-5.4296-5.5469h-75.391c-20.898 0-40.859 9.2578-54.492 23.086zm-11.836 56.367c0-18.477 8.2031-36.016 20-48.047 12.695-12.93 29.062-20.312 47.226-20.312h62.656l-129.88 145.98z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m1195.3 521.12h402.34v11.094h-402.34z",
    fill: "#1c3d75",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m1304.3 591.55h22.656v16.797h-22.656z",
    fill: "#1c3d75",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m1304.3 635.61h22.656v16.758h-22.656z",
    fill: "#1c3d75",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m1304.3 679.64h22.656v16.797h-22.656z",
    fill: "#1c3d75",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m1304.3 723.7h22.656v16.797h-22.656z",
    fill: "#1c3d75",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m1304.3 767.76h22.656v16.797h-22.656z",
    fill: "#1c3d75",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m1354.5 591.55h127.93v16.797h-127.93z",
    fill: "#1c3d75",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m1354.5 635.61h127.93v16.758h-127.93z",
    fill: "#1c3d75",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m1354.5 679.64h127.93v16.797h-127.93z",
    fill: "#1c3d75",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m1354.5 723.7h127.93v16.797h-127.93z",
    fill: "#1c3d75",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m1354.5 767.76h127.93v16.797h-127.93z",
    fill: "#1c3d75",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m870.66 844.25h-263.75v-52.07h126.88v-211.72h-126.88v-275.16h-369.49v782.42h633.24z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 40
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#br)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m1789.3 700.15c0-106.02-35.625-198.32-106.8-276.91-71.211-78.633-157.58-117.93-259.14-117.93v211.21l-62.539 0.625 0.586-208.67c-101.56 8.8281-187.46 46.367-256.48 121.56-69.024 75.195-103.52 165.04-103.52 269.45 0 108.83 38.164 201.72 114.57 278.71 76.406 76.992 169.34 115.47 278.71 115.47 108.52 0 201.41-38.398 278.71-115.27 77.227-76.836 115.9-169.57 115.9-278.24z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 40
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bg)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m2650.2 305.3h-394.61v286.17h-58.633v-286.17h-282.58v516.76h309.92v70.234h-309.92v166.95h489.65c52.969 0 97.461-19.336 133.48-57.852 36.055-38.555 54.062-84.883 54.062-138.95 0-68.242-22.578-120.55-67.734-156.88-14.766-11.523-37.344-23.086-67.695-34.57v-23.867z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 40
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#av)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m3754.5 305.3h-333.44v258.36h-58.594v-258.36h-235.7v258.36h-57.344v-258.36h-328.16v767.5l528.75-278.59 484.49 278.28z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 40
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ak)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m4923.6 305.3h-386.8v245.12l-63.789 1.3281v-246.45h-252.66v761.88h252.66v-265h63.789v265h345.16l-173.24-357.77z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 40
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 136.37)",
    d: "m5722.5 305.3h-311.25v241.13h-63.828v-241.13h-299.53v761.88h299.53v-254.41h63.828v254.41h311.25z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "m551.98 55.223-14.09 14.09-8.0273-8.0273c-0.17578-0.17578-0.46094-0.17578-0.63281 0l-2.2774 2.2734c-0.17578 0.17578-0.17578 0.46094 0 0.63281l10.41 10.41c0.28906 0.29297 0.76563 0.29297 1.0586 0l16.465-16.469c0.17578-0.17188 0.17578-0.45703 0-0.63281l-2.2734-2.2773c-0.17578-0.17188-0.46094-0.17188-0.63281 0",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m525.04 72.352 0.0117-0.05469 26.059 5.2539-8e-3 0.05469z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.04 72.375 0.0508-0.23438 26.059 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cm)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m525.07 72.219 0.0469-0.23047 26.062 5.25-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.1 72.066 0.043-0.23438 26.066 5.25-0.0508 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.13 71.91 0.0469-0.23438 26.059 5.25-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.16 71.754 0.0469-0.23438 26.059 5.2539-0.0469 0.23047z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.2 71.598 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.23 71.441 0.0469-0.23438 26.062 5.2539-0.0508 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.26 71.285 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cl)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ck)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m525.29 71.129 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.32 70.973 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.35 70.816 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.38 70.66 0.0469-0.23047 26.062 5.25-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.41 70.508 0.0469-0.23438 26.062 5.25-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.45 70.352 0.0469-0.23438 26.062 5.25-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cj)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ci)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m525.48 70.195 0.0469-0.23438 26.062 5.2539-0.0469 0.23047z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.51 70.039 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.54 69.883 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.57 69.727 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.6 69.57 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.63 69.414 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.66 69.258 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ch)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cg)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m525.7 69.102 0.0469-0.23047 26.062 5.25-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.73 68.949 0.0469-0.23438 26.062 5.25-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.76 68.793 0.0469-0.23438 26.062 5.25-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cf)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ce)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m525.79 68.637 0.0508-0.23438 26.059 5.2539-0.0469 0.23047z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.82 68.48 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.86 68.324 0.043-0.23438 26.066 5.2539-0.0508 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m525.89 68.168 0.0469-0.23438 26.059 5.2539-0.0469 0.23438z",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ca)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bz)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m525.91 68.012 0.0508-0.23438 26.059 5.2539-0.043 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.95 67.855 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#by)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bx)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m525.98 67.699 0.0469-0.23438 26.062 5.2539-0.0508 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.01 67.543 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.04 67.387 0.0469-0.23047 26.062 5.25-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.07 67.234 0.04687-0.23438 26.062 5.25-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bw)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bv)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526.11 67.078 0.0469-0.23438 26.062 5.2539-0.0469 0.23047z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.14 66.922 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.17 66.766 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bt)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526.2 66.609 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.23 66.453 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.26 66.297 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bs)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bq)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526.29 66.141 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.32 65.984 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.36 65.828 0.0469-0.23047 26.062 5.25-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bp)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bo)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526.39 65.676 0.0469-0.23438 26.062 5.25-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.42 65.52 0.0469-0.23438 26.062 5.2539-0.0469 0.23047z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.45 65.363 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bn)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bm)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526.48 65.207 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.51 65.051 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.55 64.895 0.0469-0.23438 26.059 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bl)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bk)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526.57 64.738 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.61 64.582 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.64 64.426 0.0469-0.23438 26.059 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.67 64.27 0.0469-0.23047 26.059 5.25-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bj)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bi)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526.7 64.117 0.0469-0.23438 26.062 5.25-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.73 63.961 0.0469-0.23438 26.062 5.2539-0.0469 0.23047z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.77 63.805 0.0469-0.23438 26.059 5.2539-0.043 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bh)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bf)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526.8 63.648 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.83 63.492 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.86 63.336 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#be)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526.89 63.18 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bb)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526.92 63.023 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.95 62.867 0.04688-0.23438 26.062 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#az)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526.98 62.711 0.0469-0.23047 26.062 5.25-0.0469 0.23438z",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ay)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ax)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527.02 62.559 0.0469-0.23438 26.062 5.25-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.05 62.402 0.0469-0.23438 26.062 5.2539-0.0469 0.23047z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.08 62.246 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aw)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#au)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527.11 62.09 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.14 61.934 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.17 61.777 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#at)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#as)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527.2 61.621 0.0508-0.23438 26.059 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.23 61.465 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.27 61.309 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ar)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aq)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527.3 61.152 0.0469-0.23047 26.059 5.25-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.33 61 0.0508-0.23438 26.059 5.25-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.36 60.844 0.0508-0.23438 26.059 5.2539-0.0469 0.23047z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ap)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ao)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527.39 60.688 0.0469-0.23438 26.062 5.2539-0.0508 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.43 60.531 0.0469-0.23438 26.059 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.46 60.375 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#an)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#am)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527.49 60.219 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.52 60.062 0.0469-0.23438 26.062 5.2539-0.0508 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.55 59.906 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.58 59.75 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#al)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aj)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527.61 59.594 0.0469-0.23047 26.062 5.25-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.64 59.441 0.0469-0.23438 26.062 5.25-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.68 59.285 0.0469-0.23438 26.062 5.2539-0.0469 0.23047z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ah)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527.71 59.129 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.74 58.973 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.77 58.816 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ag)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527.8 58.66 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.83 58.504 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.86 58.348 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527.89 58.191 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.93 58.035 0.0469-0.23047 26.062 5.25-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.96 57.883 0.043-0.23438 26.062 5.25-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527.99 57.727 0.0469-0.23438 26.062 5.2539-0.0469 0.23047z",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m528.02 57.57 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.05 57.414 0.0469-0.23438 26.059 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.09 57.258 0.0469-0.23438 26.059 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m528.12 57.102 0.0469-0.23438 26.062 5.2539-0.0508 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.15 56.945 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.18 56.789 0.0469-0.23438 26.062 5.2539-0.0508 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m528.21 56.633 0.0469-0.23438 26.062 5.2539-0.0508 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.24 56.477 0.0469-0.23047 26.062 5.25-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.27 56.324 0.0469-0.23438 26.062 5.25-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m528.3 56.168 0.0469-0.23438 26.062 5.2539-0.0469 0.23047z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.34 56.012 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.37 55.855 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m528.4 55.699 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.43 55.543 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.46 55.387 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.49 55.23 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.52 55.074 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.55 54.918 0.0469-0.23047 26.062 5.25-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.59 54.766 0.0469-0.23438 26.062 5.25-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m528.62 54.609 0.0469-0.23438 26.062 5.2539-0.0469 0.23047z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.65 54.453 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.68 54.297 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.71 54.141 0.043-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.74 53.984 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.77 53.828 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m528.81 53.672 0.0469-0.23438 26.059 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.84 53.516 0.0469-0.23438 26.059 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.87 53.359 0.043-0.23047 26.066 5.25-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m528.9 53.207 0.0469-0.23438 26.062 5.25-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.93 53.051 0.0469-0.23438 26.059 5.2539-0.0469 0.23047z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.96 52.895 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m529 52.738 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m529.03 52.582 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.06 52.426 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.09 52.27 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.12 52.113 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.15 51.957 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.18 51.801 0.0469-0.23047 26.062 5.25-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m529.21 51.648 0.0469-0.23438 26.062 5.25-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.25 51.492 0.0469-0.23438 26.062 5.2539-0.0469 0.23047z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.28 51.336 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.31 51.18 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.34 51.023 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.37 50.867 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#1c3d75",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m529.4 50.711 0.0469-0.23438 26.062 5.2539-0.0469 0.23438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.43 50.555 0.0312-0.13672 26.059 5.2539-0.0274 0.13672z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m138.08 112.31h2.25v-27.562h-2.25z",
    fill: "#1c3d75"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandHortColour);
export default __webpack_public_path__ + "static/media/brand-hort-colour.df6f3b8c.svg";
export { ForwardRef as ReactComponent };